'use strict';

const recaptchaConfig = require('../recaptchaConfig');

/**
 * @function
 * @description Initializes the giftcard page events
 */
exports.init = function () {
    $('input[name=dwfrm_giftcard_BalanceCheckerForm_cardNumber]').mask('0000 0000 0000 0000', {});
    $('input[name=dwfrm_giftcard_BalanceCheckerForm_cardNumberPin]').mask('000000', {});

    recaptchaConfig.defaultInitializationForFormById('BalanceCheckerForm');
};
